export default __webpack_public_path__ + "static/media/fad-squareswitch-on.22d454c6.svg";